// src/OnboardingPage.tsx
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface OnboardingPageProps {
  onOnboardingComplete: () => void; // This prop's name should match what's passed from App.tsx
}

const OnboardingPage: React.FC<OnboardingPageProps> = ({ onOnboardingComplete }) => {
  const theme = useTheme();
  const welcomeIllustrationUrl = '/Collaboration 3 Streamline Bangalore - Pro.svg'; // <--- VERIFY THIS PATH (should be the 'hands' image)
  const bg = '/Rectangle 34625731.png'
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000, // Still needs to be higher than Dashboard, but lower than ActionPopup's backdrop
        backgroundColor: 'background: rgba(249, 250, 251, 1)',
        backdropFilter: 'blur(9px)', // Blurs content behind this overlay
        WebkitBackdropFilter: 'blur(9px)',        
        transition: 'opacity 0.8s ease-in-out',
        p: { xs: 3, sm: 4 },
        borderRadius: '16px',
        textAlign: 'center',        
      }}      
    >
        <img
          src={process.env.PUBLIC_URL + welcomeIllustrationUrl}
          alt="Welcome Illustration"
          style={{ width: '150px', height: 'auto', marginBottom: theme.spacing(2) }}
        />

        <Typography sx={{ fontSize: '30px', fontWeight: 700, mb: 1, fontFamily: 'Inter' }}>
          Welcome to Horizon
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '14px', mb: 3, fontFamily: 'Inter',width:'400px' }}>
          To be able to view all critical cloud insights, you need to complete the easy two step onboarding steps.
        </Typography>

        <Button
          type="button"
          fullWidth
          variant="contained"
          onClick={onOnboardingComplete} // This will now call handleOnboardingContinue in App.tsx
          sx={{
            width:'400px',
            borderRadius: '8px',
            fontFamily: 'Inter',
            mt: 0,
            py: 1.25,
            backgroundColor: '#0064FF',
            '&:hover': {
              backgroundColor: alpha('#0064FF', 0.85),
            },
            textTransform: 'none',
          }}
        >
          Let's Get Started
        </Button>
    </Box>
  );
};

export default OnboardingPage;